export default __webpack_public_path__ + "static/project-facepass-c7516a941d59ecf9874b829e0eac84f5.png";